import { extractErrorMessage } from '@zealy/utils';
import { apiV2 } from '../services';
export const withdrawUSDC = async (data) => {
    const res = await apiV2.payout.withdraw({
        body: data,
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error(`withdrawUSDC fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
export const getWithdrawalHistory = async (params) => {
    const res = await apiV2.payout.getHistory({
        query: params || {},
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error(`getWithdrawalHistory fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
export const retrySprintDistribution = async (subdomain, data) => {
    const res = await apiV2.community.retrySprintDistribution({
        params: { subdomain },
        body: data,
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error(`retrySprintDistribution fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
